<template>
  <div>
    <b-field>
      <p class="control">
        <filter-form @filter="handleFormSubmit"></filter-form>
      </p>

      <b-input icon="magnify" type="search" v-model="filters.search" placeholder expanded></b-input>
      <div class="control">
        <button type="reset" class="button" @click="clear">
          <b-icon icon="close"></b-icon>
          <span>{{$tc('reset')}}</span>
        </button>
      </div>
    </b-field>

    <div v-if="form">
      <b-tag
        v-if="form.publisher"
        @close="form.publisher = null"
        closable
      >Publisher: {{ form.publisher.name }}</b-tag>

      <b-tag
        v-if="form.magazine"
        @close="form.magazine = null"
        closable
      >Magazine: {{ form.magazine.name }}</b-tag>

      <b-tag
        v-if="form.createdAtSince"
        @close="form.createdAtSince = null"
        closable
      >Start Date: {{ form.createdAtSince }}</b-tag>

      <b-tag
        v-if="form.createdAtUntil"
        @close="form.createdAtUntil = null"
        closable
      >End Date: {{ form.createdAtUntil }}</b-tag>

      <b-tag
        v-if="form.distributed != null"
        @close="form.distributed = null"
        closable
      >: {{ form.distributed ? "Зөвхөн олгосон" : "Зөвхөн олгоогүй" }}</b-tag>
    </div>
  </div>
</template>

<script>
import Base from "../../../../../components/BaseFilter";
import FilterForm from "./Form";

export default {
  components: {
    FilterForm
  },

  mixins: [Base],

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit("filter", this.parseForm(this.filters));
      }
    }
  },

  methods: {
    fresh() {
      return {
        search: null,
        publisher: null,
        magazine: null,
        createdAtSince: null,
        createdAtUntil: null,
        distributed: null
      };
    },

    parseForm(form) {
      return {
        "filter[search]": form.search,
        "filter[publisher_id]": form.publisher ? form.publisher.id : null,
        "filter[magazine_id]": form.magazine ? form.magazine.id : null,
        "filter[created_at_since]": form.createdAtSince,
        "filter[created_at_until]": form.createdAtUntil,
      };
    }
  }
};
</script>
